import { connect } from 'react-redux'
import compose from 'recompose/compose'
import withProps from 'recompose/withProps'
import OverflowContextMenu from '../components/OverflowContextMenu'
import { setIsWindowFullScreen } from 'aria-viewer/tour/tourActions'
import { requestFullScreen, exitFullScreen } from 'aria-viewer/utils/fullScreen'
import { showVRInstructionDrawer } from 'aria-viewer/drawer/drawerMenuActions'
import { showDescription } from 'aria-viewer/tour/tourActions'
import { Capabilities, displayFeatureBasedOnViewportSize } from 'aria-viewer/utils/capabilities'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import QueryParamUtils from 'aria-viewer/utils/queryParamUtils'
import { getEnv } from 'aria-viewer/utils/environment'

const fullLabelStyle = {
    width: '22px',
    height: '22px',
    transform: 'scale(0.8)',
}

const props = withProps(
    ({
        isVRButtonEnabled,
        isVrModuleEnabled,
        isWindowFullScreen,
        handleFullScreenButtonClick,
        handleAppilyButtonClick,
        onVrClick,
        useResponsiveUI,
        onInfoButtonClicked,
        viewportHeight,
        viewportWidth,
        isAppilyForm,
    }) => {
        const list = []
        if (isVRButtonEnabled && isVrModuleEnabled) {
            list.push({
                title: 'View in VR',
                action: onVrClick,
                icon: {
                    name: 'vr',
                    style: fullLabelStyle,
                },
                display: 'View in VR',
            })
        }
        if (!useResponsiveUI) {
            list.push({
                title: 'Fullscreen',
                action: handleFullScreenButtonClick,
                icon: {
                    name: isWindowFullScreen ? 'minimize' : 'expand',
                    style: fullLabelStyle,
                },
                display: 'Fullscreen',
            })
        }
        if (
            displayFeatureBasedOnViewportSize(Capabilities.OVERFLOW_MENU_TOUR_BUTTON, {
                viewportHeight,
                viewportWidth,
            }) &&
            useResponsiveUI
        ) {
            list.push({
                title: 'Info',
                action: onInfoButtonClicked,
                icon: {
                    name: 'info_desktop',
                },
            })
        }
        if (useResponsiveUI) {
            list.push({
                title: 'Language',
            })
            list.push({
                title: 'Share',
            })
        }
        if (isAppilyForm) {
            list.push({
                title: 'Appily College Search',
                action: handleAppilyButtonClick,
                icon: {
                    name: 'logout_svg',
                    style: fullLabelStyle,
                },
                display: 'Appily College Search',
            })
        }
        return {
            options: {
                list,
            },
        }
    }
)

const mapStateToProps = state => ({
    isMobile: state.getIn(['device', 'isDeviceMobile']),
    isWindowFullScreen: state.getIn(['tour', 'isWindowFullScreen']),
    isVRButtonEnabled: state.getIn(['config', 'isVRButtonEnabled']),
    useResponsiveUI: state.getIn(['device', 'useResponsiveUI']),
    viewportWidth: state.getIn(['device', 'viewportWidth']),
    viewportHeight: state.getIn(['device', 'viewportHeight']),
    isAppilyForm: state.getIn(['registration', 'formType']) === 'appily',
})

const mapDispatchToProps = dispatch => ({
    onFullScreenButtonClick: isWindowFullScreen => {
        if (isWindowFullScreen) {
            exitFullScreen()
            dispatch(setIsWindowFullScreen(false))
        } else {
            requestFullScreen()
            dispatch(setIsWindowFullScreen(true))
        }
    },

    onInfoButtonClicked: () => {
        dispatch(showDescription())
    },

    onVrClick: item => {
        dispatch(showVRInstructionDrawer())
    },
})

const mergeProps = (state, actions, ownProps) => ({
    ...state,
    ...actions,
    ...ownProps,

    handleFullScreenButtonClick: item => {
        const { isWindowFullScreen } = state

        actions.onFullScreenButtonClick(isWindowFullScreen)
    },
    handleAppilyButtonClick: () => {
        window.open(`${getEnv('REACT_APP_CAPPEX_URL')}/dashboard`, '_blank', 'noreferrer')
    },
})

export default compose(
    connect(mapSelectorsToProps(['isVrModuleEnabled'])),
    connect(mapStateToProps, mapDispatchToProps, mergeProps),
    props
)(OverflowContextMenu)
